import React, { Component } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import ResumeItem from "./ResumeItem";
import resume from "../docs/GrayGunter_resume.pdf";
import resumeData from "../json/resume.json";

class Resume extends Component {

    constructor() {
        
        super();

        this.generateResume = this.generateResume.bind(this);
    
    }

    generateResume(resumeItem, index) {
        return (
            <ResumeItem
                company={resumeItem["company"]}
                endDate={resumeItem["end-date"]}
                featuredClients={resumeItem["featured-clients"]}
                freelance={resumeItem["freelance"]}
                highlights={resumeItem["highlights"]}
                jobDetails={resumeItem["job-details"]}
                jobTitle={resumeItem["job-title"]}
                key={resumeItem + index}
                links={resumeItem["links"]}
                skills={resumeItem["skills"]}
                startDate={resumeItem["start-date"]}
                title1={resumeItem["title1"]}
                title2={resumeItem["title2"]}
            />
        )
    }

    render() {
        return (
            <div className={classNames("section","resume")}>

                <div className="section-title">
                    <span className="code">
                        <span className="blue">&#123;</span> 
                        <span className="yellow"> /* </span>
                        <span className="red">resume</span>
                        <span className="yellow"> */ </span>
                        <span className="blue">&#125;</span>
                        <span className="cursor">|</span>
                    </span>
                </div>

                <div className="resume-and-linkedIn">

                    <a 
                        className="resume-download"
                        href={resume}
                        rel="noreferrer"
                        target="_blank">
                        <FontAwesomeIcon icon="fa-solid fa-file-arrow-down"/>
                        &nbsp;&nbsp;Download Full Resume
                    </a>

                    <a 
                        className="linkedIn"
                        href="https://www.linkedin.com/in/graygunter/"
                        rel="noreferrer"
                        target="_blank">
                        <FontAwesomeIcon icon="fa-brands fa-linkedin"/>
                        &nbsp;&nbsp;graygunter
                    </a>

                </div>

                <div className="resume-container">
                    {Array.from(resumeData.resume).map(this.generateResume)}
                </div>

            </div>
        );

    }
}
  
export default Resume;